<div class="p-4 justify-content-between m-2 mt-4">
  <form [formGroup]="form" class="d-inline-flex" (ngSubmit)="onSubmit()">
    <div>
      <input class="mr-2" trimValueAccessor formControlName="templateFolder" placeholder="Folder"/>
      <input class="mr-2" trimValueAccessor formControlName="templateName" placeholder="Template Name"/>
      <input class="mr-2" trimValueAccessor formControlName="language" placeholder="Language" value="E"/>

      <!--      <select formControlName="language" class="p-2 mr-2">-->
      <!--        <option value="" disabled>Language</option>-->
      <!--        <option *ngFor="let opt of languageOptions" [value]="opt.value">-->
      <!--          {{ opt.label }}-->
      <!--        </option>-->
      <!--      </select>-->
      <button type="submit" pButton class="btn btn-primary">Submit</button>
    </div>
  </form>
</div>
